import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

/* eslint-disable no-console */
if (import.meta.env.PROD) {
  console.log = () => {};
  console.warn = () => {};
  console.info = () => {};
  console.debug = () => {};
  // Keep console.error for critical issues only
}
/* eslint-enable no-console */

// --- Service Worker Cleanup (Critical for SEO) ---
// This acts as a client-side "kill switch" for any previously installed SWs.
const unregisterServiceWorkers = () => {
  // Guard: Environment check
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) {
    return;
  }

  // Helper to safely execute the unregister logic
  const performCleanup = async () => {
    // Delay slightly to ensure document is in valid state (fixes InvalidStateError)
    await new Promise((resolve) => setTimeout(resolve, 100));

    try {
      // Check if the API is actually available in this context
      if (!navigator.serviceWorker.getRegistrations) return;

      const registrations = await navigator.serviceWorker.getRegistrations();

      if (registrations.length > 0) {
        console.warn(
          `[SW-Cleanup] Found ${registrations.length} active Service Workers. Purging...`
        );

        await Promise.all(
          registrations.map(async (registration) => {
            try {
              const success = await registration.unregister();
              if (success) console.warn(`[SW-Cleanup] Unregistered SW at: ${registration.scope}`);
            } catch (err) {
              console.warn('[SW-Cleanup] Failed to unregister specific SW:', err);
            }
          })
        );

        // Optional: Force reload if we found and killed a SW to ensure clean state
        // window.location.reload();
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      // Suppress "InvalidStateError" which occurs if the document is unloading
      // or in a transition state (common during rapid development reloads).
      if (
        error?.name === 'InvalidStateError' ||
        error?.message?.includes('invalid state') ||
        error?.message?.includes('InvalidStateError')
      ) {
        return;
      }
      console.error('[SW-Cleanup] Unexpected error:', error);
    }
  };

  // Execution: Run immediately if loaded, otherwise wait for load event
  if (document.readyState === 'complete') {
    performCleanup();
  } else {
    window.addEventListener('load', performCleanup);
  }
};

// Execute cleanup
unregisterServiceWorkers();

const rootElement = document.getElementById('root')!;

// Use hydrate for react-snap pre-rendering
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
